import React, { useState } from 'react';
import { IonFab, IonFabButton, IonFabList, IonIcon } from '@ionic/react';
import { ellipsisVertical, closeOutline } from 'ionicons/icons';

export interface FABAction {
  id: string;
  icon: string;
  label: string;
  onClick: () => void;
  color?: string;
  disabled?: boolean;
}

export interface DashboardFABProps {
  actions: FABAction[];
  position?: 'bottom-right' | 'bottom-left';
  mainIcon?: string;
  className?: string;
  showLabels?: boolean;
}

const DashboardFAB: React.FC<DashboardFABProps> = ({
  actions,
  position = 'bottom-right',
  mainIcon = ellipsisVertical,
  className = '',
  showLabels = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleActionClick = (action: FABAction) => {
    if (action.disabled) return;
    action.onClick();
    setIsOpen(false);
  };

  const handleBackdropClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Backdrop when FAB is open */}
      <div
        className={`fab-backdrop ${isOpen ? 'visible' : ''}`}
        onClick={handleBackdropClick}
      />

      <IonFab
        vertical="bottom"
        horizontal={position === 'bottom-right' ? 'end' : 'start'}
        slot="fixed"
        className={`view-mode-fab ${className}`}
        activated={isOpen}
      >
        <IonFabButton onClick={() => setIsOpen(!isOpen)}>
          <IonIcon icon={isOpen ? closeOutline : mainIcon} />
        </IonFabButton>
        <IonFabList side="top">
          {actions.map((action) => (
            <IonFabButton
              key={action.id}
              onClick={() => handleActionClick(action)}
              disabled={action.disabled}
              style={action.color ? { '--color': action.color } as React.CSSProperties : undefined}
            >
              {showLabels && <span className="fab-button-label">{action.label}</span>}
              <IonIcon icon={action.icon} />
            </IonFabButton>
          ))}
        </IonFabList>
      </IonFab>
    </>
  );
};

export default DashboardFAB;
